/* eslint-disable react/prop-types */
import { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

// Components
import ScheduleList from './pages/ScheduleList';
import NewSchedule from './pages/NewSchedule';

export default class Scheduling extends Component {
  render() {
    const { match } = this.props;
    return (
      <div className="Scheduling">
        <Switch>
          <Route path={`${match?.url}/novo`} component={NewSchedule} />
          <Route component={ScheduleList} />
        </Switch>
      </div>
    );
  }
}
